import { setQueryParam } from "../utils/helper"

document.addEventListener("DOMContentLoaded", () => {
    const tabs = document.querySelector("#getting-around-tabs")

    if (!tabs) {
        return
    }

    const tabButtons = [...tabs.querySelectorAll("button")]

    console.log({ buttons: tabButtons })

    for (const button of tabButtons) {
        button.addEventListener("click", () => {
            setQueryParam("tab", button.name.toLowerCase())
            var tabContent = button.id.split("-tab")[0]
            document.location.hash = tabContent
        })
    }

    const currentUrl = new URL(location.href)
    const preselectedTab = currentUrl.searchParams.get("tab")
    if (preselectedTab) {
        tabButtons.find(x => x.name.toLowerCase() === preselectedTab)?.click()
    }
})
